/** @jsx jsx */
import { jsx, SxStyleProp } from 'theme-ui';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { GatsbyLinkProps } from 'gatsby';
import { AnchorHTMLAttributes } from 'react';

// Extend the properties with Theme UI's SxStyleProp
export interface UAnchorLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement>, GatsbyLinkProps<any> {
  sx?: SxStyleProp;
}

export const UAnchorLink: React.FC<UAnchorLinkProps> = ({ children, to, sx, ...props }) => {
  return (
    <AnchorLink
      to={to}
      {...props} // Spread additional props to support all native AnchorLinkProps
      sx={sx} // Apply the sx prop correctly
    >
      {children}
    </AnchorLink>
  );
};

